// Entity
import { BucketTaskboardTaskFormattingBuilder } from "../../legacyPlanner/task/taskFormatting/BucketTaskboardTaskFormattingBuilder";
/** Class to handle serialization/deserialization for TaskBoardFormatBucket data */ export class TaskBoardFormatBucketSerializationHandler {
    /** serialize to IGraphBucketTaskBoardTaskFormattingResource */ toSerializable(key, value) {
        return value.toGraphSerializable();
    }
    /** build IBucketTaskboardTaskFormatting from IGraphBucketTaskBoardTaskFormattingResource */ fromSerializable(key, serializableValue) {
        return new BucketTaskboardTaskFormattingBuilder().fromGraphResource(serializableValue).build();
    }
}
